// extracted by mini-css-extract-plugin
export default {"root":"statistics_root__yW7yJ","title":"statistics_title__xBvYJ","cards":"statistics_cards__UKsOh","btn":"statistics_btn__wxVVA"};